import React, { useEffect, useRef, useState } from "react";
import SelectBox from "../../../../components/elements/form/selectBox";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import Currency from "../../../../components/currency";

interface CreateReceiptPartsProps {
    data: Array<any>;
    onUpdate?: (data: Array<any>) => void;
}
const CreateReceiptParts: React.FC<CreateReceiptPartsProps> = ({ data, onUpdate = (data: Array<any>) => { } }) => {
    const divRef = useRef<any>(null);
    const sparePartsAPI = useSpearPartsApi();
    const commonApi: any = useCommonApi();
    const blankpartmodel = {
        partsID: null,
        partCode: ``,
        PartName: ``,
        vendorPartCode: ``,
        unitCost: 0,
        unitCode: ``,
        unitID: null,
        orderedQty: 0,
        deliveredQty: 0,
        receivingQty: 0,
        totalValue: 0,        
    };

    const [partsItems, setPartsItems] = useState<any[]>(data || []);

    const [lastSearchParts, setLastSearchParts] = useState([]);
    const [vendorList, setVendorList] = useState<any[]>([]);

    const onOutsideClick = () => {
        handleOnClickCellEdit()
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }

    };

    const handlePartsSearch = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            sparePartsAPI.getSpearPartsList({
                pageSize: 10,
                pageNumber: 1,
                searchParam: inputval,
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`sparePartsList`) && Array.isArray(resp.sparePartsList) && resp.sparePartsList.length > 0) {
                    const bindParts = resp.sparePartsList.map((part: any) => {
                        return {
                            value: part.partsCode,
                            label: part.partName,
                        };
                    });
                    setLastSearchParts(resp.sparePartsList);
                    resolve(bindParts);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const handleVendorSearch = async (inputval: any): Promise<any[]> => {        
        return new Promise((resolve, reject) => {            
            commonApi.GetServiceprovidertList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0 ) {
                    /*
                    const deptlist = resp.vendorList.map((user: any) => {
                        return {
                            label: user.name,
                            value: user.vendorID,
                        };
                    });
                    resolve(deptlist);
                    */
                    resolve(resp.vendorList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const init_page_data = async () => {
        const vendorlist = await handleVendorSearch(``);
        setVendorList(vendorlist);
    };

    useEffect(() => {
        // set dummy data
        init_page_data();
        
        /*
        setPartsItems([{
            partsID: 1,
            partCode: `ARP1746083436`,
            PartName: `Brake Pad`,
            vendorPartCode: `ARPV1746083436`,
            unitCost: 50,
            unitCode: `Pcs`,
            unitID: 12,
            orderedQty: 10,
            deliveredQty: 5,
            receivingQty: 5,
            totalValue: 500,
        },
        {
            partsID: 2,
            partCode: `ARP1746083437`,
            PartName: `Oil Filter`,
            vendorPartCode: `ARPV174608396`,
            unitCost: 15,
            unitCode: `Cms`,
            unitID: 13,
            orderedQty: 20,
            deliveredQty: 20,
            receivingQty: 0,
            totalValue: 300,
        },
        {
            partsID: 3,
            partCode: `ARP1746083440`,
            PartName: `Air Filter`,
            vendorPartCode: `ARPV1746083497`,
            unitCost: 18,
            unitCode: `Inch`,
            unitID: 14,
            orderedQty: 15,
            deliveredQty: 10,
            receivingQty: 5,
            totalValue: 270,
        },
        {
            partsID: 4,
            partCode: `ARP1746083441`,
            PartName: `Spark Plug`,
            vendorPartCode: `ARPV1746083442`,
            unitCost: 8,
            unitCode: `Pcs`,
            unitID: 16,
            orderedQty: 40,
            deliveredQty: 30,
            receivingQty: 10,
            totalValue: 320,
        },
        {
            partsID: 5,
            partCode: `ARP1746083442`,
            PartName: `Timing Belt`,
            vendorPartCode: `ARPV1746083443`,
            unitCost: 120,
            unitCode: `Kg`,
            unitID: 17,
            orderedQty: 5,
            deliveredQty: 2,
            receivingQty: 3,
            totalValue: 600,
        },
        {
            partsID: 6,
            partCode: `ARP1746083443`,
            PartName: `Radiator Hose`,
            vendorPartCode: `ARPV1746083444`,
            unitCost: 35,
            unitCode: `Mm`,
            unitID: 18,
            orderedQty: 8,
            deliveredQty: 8,
            receivingQty: 0,
            totalValue: 280,
        }])
        */

    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClick]);

    console.log('partsItems',partsItems);
    

    return (
        <div>
            <div className="flex justify-between items-center mt-1">
                <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>LINE ITEMS</h4>               
            </div>
            {/* total width 849px */}
            <div className={`border border-[#043E6133] rounded-[5px] w-[1055px] overflow-x-auto  parts-table`}>
                <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`w-36 min-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center sticky left-0`}>Part Code</div> {/* 144px */}
                    <div className={`w-[200px] min-w-[200px] font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Part Name</div> {/* 270px */}
                    <div className={`w-36 min-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Vendor Part Code</div> {/* 144px */}                    
                    <div className={`w-28 min-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Unit Cost</div> {/* 112px */}
                    <div className={`w-28 min-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Ordered Qty</div> {/* 112px */}                    
                    <div className={`w-28 min-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Delivered Qty</div> {/* 112px */}
                    <div className={`w-28 min-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end sticky right-28`}>Receiving Qty</div> {/* 112px */}
                    <div className={`w-28 min-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[13px] px-2.5 py-2 h-[50px] grow flex items-center justify-end sticky right-0`}>Total Value</div> {/* 112px */}
                </div>
                <div ref={divRef}>
                    {partsItems.length === 0 && (
                        <div className={`flex items-center justify-center h-24 text-gray-500`}>
                            No parts added yet.
                        </div>
                    )}
                    {partsItems.map((part, index) => (                        
                        <div className={`flex items-center flex-nowrap`} key={`part-item-${index}`}>
                            <div className={`w-36 min-w-36 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed sticky left-0 ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>{part.partsCode || `--`}</div>
                            <div className={`w-[200px] min-w-[200px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1`} title={part.partsName || `--`}>{part.partsName || `--`}</div>
                            </div>
                            <div className={`w-36 min-w-36 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>{part.vendorPartCode || `--`}</div>
                            <div className={`w-28 min-w-28 font-normal text-[#42484B] bg-white text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col editable cursor-pointer ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-cost-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-cost-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`text-right`}>
                                    <div className={`preview-value`} title={(+part.unitCost > 0)? (`Unit Cost: $` + part.unitCost): `Click here to edit`}><Currency currency="USD" value={part.unitCost || 0} /></div>
                                    <div className={`edit-value hidden`}>
                                        <input
                                            type="number"
                                            className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner`}
                                            value={part.unitCost}
                                            min={0}
                                            step="0.01"
                                            onInput={(e: any) => {
                                                const newCost = e.target.value;
                                                const updatedParts = [...partsItems];
                                                updatedParts[index].unitCost = newCost;
                                                updatedParts[index].totalValue = updatedParts[index].receivingQty * (+newCost || 0);
                                                setPartsItems(updatedParts);
                                                onUpdate(updatedParts);
                                            }}
                                            onBlur={(e: any) => {
                                                const newCost = e.target.value;
                                                const updatedParts = [...partsItems];
                                                updatedParts[index].unitCost = isNaN(+newCost) ? 0 : (+newCost > -1 ? +newCost : 0);
                                                updatedParts[index].totalValue = updatedParts[index].receivingQty * updatedParts[index].unitCost;
                                                setPartsItems(updatedParts);
                                                onUpdate(updatedParts);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`w-28 min-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1 text-right`}>{part.orderedQty || 0} {part.unitCode}</div>                                
                            </div>
                            <div className={`w-28 min-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value line-clamp-1 text-right`}>{part.deliveredQty || 0} {part.unitCode}</div>                                
                            </div>                                                    
                            
                            <div className={`w-28 min-w-28 font-normal text-[#42484B] bg-white text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-end flex-col editable cursor-pointer sticky right-28 ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-item-qty-${index}`} onClick={(e: any) => {
                                handleOnClickCellEdit(`part-item-qty-${index}`, e);
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <div className={`text-right`}>
                                    <div className={`preview-value`} title={(+part.receivingQty > 0)? (`Quantity is: ` + part.receivingQty): `Click here to add data`}>{part.receivingQty || 0} {part.unitCode}</div>
                                    <div className={`edit-value hidden`}>
                                        <div className={ `flex items-center justify-end gap-1` }>
                                            {[1,5].includes(+part.unitID)? (
                                                <input
                                                    type="tel"
                                                    className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                    value={part.receivingQty}
                                                    onChange={(e) => {
                                                        const newQty = +e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].receivingQty = isNaN(newQty) ? 0 : newQty;
                                                        updatedParts[index].totalValue = updatedParts[index].receivingQty * updatedParts[index].unitCost;
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                />
                                            ): (
                                                <input
                                                    type="number"
                                                    name={`requiredQtyxx${index}`}
                                                    className={ `w-full border border-gray-300 rounded px-2 py-1 outline-none text-right input-no-spinner` }
                                                    value={part.receivingQty}
                                                    min={0}                                        
                                                    onInput={(e:any) => {
                                                        const newQty = e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        //console.log(e.target.value);                                                                                                
                                                        //console.log(newQty);
                                                        //updatedParts[index].unitPrice = isNaN(newQty) ? 0 : newQty;
                                                        updatedParts[index].receivingQty = newQty;
                                                        updatedParts[index].totalValue = updatedParts[index].receivingQty * updatedParts[index].unitCost;
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);                                                
                                                    }}
                                                    onBlur={(e:any) => {
                                                        const newQty = e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].receivingQty = isNaN(newQty) ? 0 : (+newQty > -1? +newQty: 0);
                                                        updatedParts[index].totalValue = updatedParts[index].receivingQty * updatedParts[index].unitCost;
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                    /*
                                                    onChange={(e) => {                                                    
                                                        const newQty = +e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].requiredQty = isNaN(newQty) ? 0 : newQty;
                                                        setPartsItems(updatedParts);
                                                        onUpdate(updatedParts);
                                                    }}
                                                    */
                                                />
                                            )}



                                            
                                            {/*
                                            <input
                                                type="tel"
                                                className={ `w-full border border-gray-300 rounded px-2 py-1 outline-none text-right` }
                                                value={part.receivingQty || 0}
                                                onChange={(e) => {                                                    
                                                    const newQty = +e.target.value;
                                                    const updatedParts = [...partsItems];
                                                    updatedParts[index].receivingQty = isNaN(newQty) ? 0 : newQty;
                                                    updatedParts[index].totalValue = updatedParts[index].receivingQty * updatedParts[index].unitCost;
                                                    setPartsItems(updatedParts);
                                                    onUpdate(updatedParts);
                                                }}
                                            />
                                            */}
                                            <div>{part.unitCode}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`w-28 min-w-28 font-normal text-[#42484B] text-[15px] px-2.5 py-3 bg-[#F9F9F9] cursor-not-allowed sticky right-0 ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                <div className={`preview-value text-right`}><Currency currency="USD" value={part.totalValue || 0} /></div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>            

        </div>
    );
};
export default CreateReceiptParts;